module.exports = __webpack_public_path__ + "static/img/dingd.026742a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dingd.png
// module id = Ev42
// module chunks = 1